import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';

import { Routes } from './routes';

import 'react-block-ui/style.css';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import './styles/global.scss';
import './utils/yupCustomMethods';

import { theme } from './styles/theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
